import React from 'react'

import useWindowDimensions from '../../../hooks/useWIndowDimentions'
import styles from './ReadProgress.module.scss'

type Props = {
  scrollPos: number
  contentRef: any
}

const ReadProgress: React.FC<Props> = ({ scrollPos, contentRef }) => {
  const { height } = useWindowDimensions()
  const contentHeight = (contentRef.current?.clientHeight || 0) - (height || 0)
  return (
    <div
      className={styles.loader}
      style={{
        width: scrollPos ? `${Math.max(0, Math.min(100, (scrollPos / contentHeight) * 100))}%` : 0,
      }}
    />
  )
}

export default ReadProgress
